import Component from "../abstracts/Component";

const CONTACT_US_IDS={
  PERSONAL_STYLIST: "personal_stylist",
    PRODUCT_AND_BOX_DAMAGED: "product_and_box_damaged",
    SOME_PRODUCT_ACCESSORIES_ARE_MISSING: "some_product_accessories_are_missing",
    DAMAGED_OR_FAULTY_PRODUCT: "damaged_or_faulty_product",
    WRONG_PRODUCT: "wrong_product",
    WRONG_COLOUR: "wrong_colour",
    PRODUCT_DESCRIPTION_MISMATCHING: "product_description_mismatching",
    ORDER_ARRIVED_AFTER_SCHEDULED_DATE: "order_arrived_after_scheduled_date",
    CHANGED_MY_MIND: "changed_my_mind",
    DONT_LIKE_COLOUR: "dont_like_colour",
    DOESNT_SUIT: "doesnt_suit",
    TOO_SMALL: "too_small",
    TOO_BIG: "too_big",
    OTHER: "other",
    PRIVACY_AND_DATA_PROTECTION: "privacy_and_data_protection",
    ORDERS_AND_DELIVERIES: "orders_and_deliveries",
    PAYMENTS_AND_PROMOTIONS: "payments_and_promotions",
    COLLABORATIONS: "collaborations",
    COMMENTS_AND_SUGGESTIONS: "comments_and_suggestions",
    PRODUCT_INFO_AND_AVAILABILITY: "product_info_and_availability",
    STORES: "stores",
    REFUND_AND_RETURNS: "refund_and_returns",
    TECHNICAL_ASSISTANCE: "technical_assistance",
    RECEIVED_ITEM_WASNT_THE_ORDERED_ONE: "received_item_wasnt_the_ordered_one",
    DOEST_FIT_ME: "doest_fit_me",
    WRONG_SIZE_OR_COLOUR_ORDERED: "wrong_size_or_colour_ordered",
    IMAGINED_ITEM_DIFFERENT: "imagined_item_different",
    RETAIL_STORES: "retail_stores",
    STOCKS_IN_PHYSICAL_STORES: "stocks_in_physical_stores",
    REPAIRS: "repairs",
    PRODUCT_CARE: "product_care",
    ABOUT_MAX_MARA: "about_max_mara",
}


export default class ContactUsComponent extends Component {
  get SELECTORS() {
    return {
      main: '#contactUsForm',
      subject: '.js-contact-subject',
      returns: '.js-subject-returns',
      orders: '.js-subject-orders',
      blocks: '.js-subject',
      subjectCode: '.js-subject-code',
      contactUs: '.contactUsPageGReCaptchaChallange'
    }
  }

  constructor() {
    super()
  }

  submitForm(data, url) {
    return $.ajax({
      url: url,
      method: 'POST',
      data: data,
    });
  }

  showAdditionalData(id) {
    const ordersBlock = document.querySelector(this.SELECTORS.orders);
    const returnsBlock = document.querySelector(this.SELECTORS.returns);
    if(id) {
      switch (id) {
        case CONTACT_US_IDS.REFUND_AND_RETURNS:
          (ordersBlock ? ordersBlock.classList.add('d-none') : false);
          (returnsBlock ? returnsBlock.classList.remove('d-none') : false);
          break;
        case CONTACT_US_IDS.DAMAGED_OR_FAULTY_PRODUCT:
          (returnsBlock ? returnsBlock.classList.add('d-none') : false);
          (ordersBlock ? ordersBlock.classList.remove('d-none') : false);
          break;
        default:
          (ordersBlock ? ordersBlock.classList.add('d-none') : false);
          (returnsBlock ? returnsBlock.classList.add('d-none') : false);
      }
    }else{
      (ordersBlock ? ordersBlock.classList.add('d-none') : false);
      (returnsBlock ? returnsBlock.classList.add('d-none') : false);
    }
    document.querySelector(this.SELECTORS.subjectCode).value = id;
  }

  bindSubject() {
    // context
    let ctx = this;
    this.$on('change', ({event}) => {
      //
      const currentTarget = event.currentTarget;
      this.showAdditionalData($(':selected',currentTarget).attr('id'));
      //
      ctx.manageBlocks();
    }, 'body', this.SELECTORS.subject);
  }

  manageBlocks() {
    let blocks = $(this.SELECTORS.main).find(this.SELECTORS.blocks);
    if (blocks === null) return false;
    blocks.each(function() {
      let $input = $(this).find('input, select');
      if ($(this).hasClass('d-none')) {
        $input.prop('disabled', true);
      } else {
        $input.prop('disabled', false);
      }
    })
  }

  bindSubmit() {
    let ctx = this;
    this.$on('submit', ({event}) => {
      this.$emit(this.$customEvents.FORM_EVENTS.formSubmitted);
      event.preventDefault();
      if (!window.RecaptchaComponent.getResponseFromWidget('contactUsPage')) {
        // User have not completed the challenge
        return;
      }

      if($(this.SELECTORS.subject).find(':selected').attr('id') == CONTACT_US_IDS.REFUND_AND_RETURNS) {
        if($("input[name='datePick']").val() == '') {
          $("input[name='datePick']").prop("disabled", true);
        }
      }
      var disabled = $('#contactUsForm').find('select:disabled').removeAttr('disabled');
      const form = $(event.target).serialize();
      disabled.attr('disabled','disabled');

      const action = event.currentTarget.getAttribute('action');
      //
      event.target.classList.add('sending');
      document.querySelector(this.SELECTORS.contactUs).setAttribute('disabled', 'disabled');
      // data.concat(`&${this.getSubjectCode()}`);
      this.submitForm(form, action).then(res => {
        // get returned html
        const responseHtml = new DOMParser().parseFromString(res, 'text/html');
        // errors check
        if (responseHtml.querySelector('.error-msg') ) {
          // replace form
          event.currentTarget.parentElement.querySelector('.form-content').innerHTML = responseHtml.querySelector('.form-content').innerHTML;
          ctx.manageBlocks();
        } else {
          // show than you msg
          event.currentTarget.parentElement.innerHTML = res;
        }
        // launch event
        this.$emit(this.$customEvents.FORM_EVENTS.formReplaced, {event: event});
        //
        event.target.classList.remove('sending');
      });
    }, 'body', this.SELECTORS.main);
  }

  render() {
    this.log('rendering...');
    this.bindSubmit();
    if (document.querySelector(this.SELECTORS.returns) || document.querySelector(this.SELECTORS.orders)) {
      this.bindSubject();
      if($(this.SELECTORS.subject)) {
        $(this.SELECTORS.subject).trigger('change');
      }
    }
  }
}
